import { exports as t, __module as n } from "../../../_virtual/eventNames.mjs";
(function(a, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = ["ready", "stateChange", "playbackQualityChange", "playbackRateChange", "error", "apiChange", "volumeChange"], a.exports = e.default;
})(n, t);
//# sourceMappingURL=eventNames.mjs.map
